import React, {useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";
import CancelButton from "../../../components/buttons/CancelButton";
import FormFieldText from "../../../components/FormFieldText";
import SaveButton from "../../../components/buttons/SaveButton";

export type VisitorRequestInfoCardDialogProps = {
    onCancel: () => void;
    onOk: (value: string) => void;
    open: boolean;
};

const VisitorRequestInfoCardDialog: React.FC<VisitorRequestInfoCardDialogProps> = (props) => {
    const intl = useIntl();

    const [cardNumber, setCardNumber] = useState('');

    const handleOk = () => {
        if (cardNumber) {
            props.onOk(cardNumber);
        }
    };

    const handleCancel = () => {
        props.onCancel();
    }

    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth={true}>
            <DialogTitle>
                <FormattedMessage id={'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_PLACEHOLDER'}/>
            </DialogTitle>
            <DialogContent>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER"})}
                               required={true}
                               autoFocus={true}
                               value={cardNumber}
                               onChange={(value) => {
                                   setCardNumber(value)
                               }}/>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleCancel}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
};

export default VisitorRequestInfoCardDialog;